const autocompleteModalFilterUser = {
  site: 'Sites',
  role: 'Profiles'
};

export default autocompleteModalFilterUser;
